export const preSaleAddress = "0x92De86c6A105D80cd43b70D6561E44208D95184E";
export const pltToken = "0x1E3B5Ac35B153BB0A6F6C6d46F05712E102FE42E";
